import { render } from "./MyTraining.vue?vue&type=template&id=220fd662&scoped=true"
import script from "./MyTraining.vue?vue&type=script&lang=js"
export * from "./MyTraining.vue?vue&type=script&lang=js"

import "./MyTraining.vue?vue&type=style&index=0&id=220fd662&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220fd662"]])

export default __exports__